import { AccountArrowUpOutlineIcon } from './AccountArrowUpOutlineIcon';

/**
 * author: Colton Wiscombe
 * id A5BAE236-3B16-41B5-B779-435AD2A6DAEE
 * name account-arrow-up-outline
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-arrow-up-outline.svg
 * tags
 * - Account / User 
 */
export const AccountUploadOutlineIcon = AccountArrowUpOutlineIcon;
export default AccountUploadOutlineIcon